import PropTypes from 'prop-types';
import Container from '@/components/Container';
import Link from '@/components/Link';
import TrainingListingCard from '@/domain/Training/TrainingListingCard';
import client from '@/api/client';
import { trainingListingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({ query: trainingListingQuery });

  return {
    props: {
      trainings: data?.trainings?.nodes || [],
    }
  }
}

const defaultProps = {
  trainings: [],
};

const propTypes = {
  trainings: PropTypes.arrayOf(PropTypes.object),
};

export default function TrainingListing({
  trainings,
}) {
  return (
    <div>
      <div className="bg-white shadow-sm relative z-10">
        <Container>
          <div className="flex items-center relative -mb-px space-x-4 lg:space-x-6">
            <span className="font-medium py-4 px-1 flex items-center border-b-2 text-green-500 border-green-500">
              Entrenamientos
            </span>
            <Link className="font-medium py-4 px-1 flex items-center border-b-2 border-transparent text-gray-500 hover:text-gray-900" href="/certificaciones">
              Certificaciones
            </Link>
          </div>
        </Container>
      </div>
      <div className="py-10 bg-gray-100 space-y-10">
        <Container>
          <div className="bg-gray-900 text-gray-100 rounded-lg shadow-lg px-4 py-3 text-lg" role="alert">
            <div className="flex items-start md:items-center space-x-3">
              <div className="mt-1 md:mt-0">
                <svg className="w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="font-medium flex-1">
                Todos nuestros entrenamientos tienen la certificación incluida
              </div>
            </div>
          </div>
        </Container>
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            {trainings.map(({ id, ...training }) => (
              <div key={`training-listing-${id}`}  className="lg:col-span-6 flex">
                <TrainingListingCard {...training} />
              </div>
            ))}
          </div>
        </Container>
      </div>
    </div>
  );
}

TrainingListing.defaultProps = defaultProps;
TrainingListing.propTypes = propTypes;
